export default "__VITE_ASSET__fYMi2Qm2__"